import VueRouter from 'vue-router'


const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      component: () => import('@/views/home')
    },
    {
      path: '/login',
      component: () => import('@/views/newLoginPage')
    },
    {
      path: '/fileManager',
      component: () => import('@/views/panel'),
      redirect: '/lesson',
      children: [
        {
          path: '/lesson',
          component: () => import('@/components/lesson'),
        },
        {
          path: '/ppt',
          component: () => import('@/components/aiPpt'),
        }, {
          path: '/ques',
          component: () => import('@/components/aiQues'),
        }, {
          path: '/doc',
          component: () => import('@/components/mineDoc'),
        }, {
          path: '/lib',
          component: () => import('@/components/lib'),
        }, {
          path: '/service',
          component: () => import('@/components/service'),
        }]
    },
    {
      path: '/panel',
      component: () => import('@/views/fileManager')
    },
    {
      path: '/legal',
      component: () => import('@/views/legal/index'),
      children: [
        {
          path: '/legal/proto',
          component: () => import('@/views/legal/proto'),
        },
        {
          path: '/legal/privacy',
          component: () => import('@/views/legal/privacy'),
        },
        {
          path: '/legal/agreement',
          component: () => import('@/views/legal/agreement'),
        },
      ]
    },
    {
      path: '/legalhistory',
      component: () => import('@/views/legal/history')
    },
    {
      path: '/legalpublicity',
      component: () => import('@/views/legal/publicity')
    },
    {
      path: '/admin',
      component: () => import('@/views/admin'),
      redirect: '/expAudit'
    },
    {
      path: '/expAudit',
      component: () => import('@/views/admin')
    },
    {
      path: '/useFb',
      component: () => import('@/views/admin')
    },
    {
      path: '/ideaFb',
      component: () => import('@/views/admin')
    },
    {
      path: '/userLog',
      component: () => import('@/views/admin')
    },
    {
      path: '/logStat',
      component: () => import('@/views/admin')
    },
    {
      path: '/fileQuery',
      component: () => import('@/views/admin')
    },
    {
      path: '/memberService',
      component: () => import('@/views/admin')
    },
    {
      path: '/retail',
      component: () => import('@/views/retailPage')
    }
    // {
    //   path: '/receipt',
    //   component: () => import('@/views/receipt')
    // }
  ]
})

export default router
